import { Box, Card, CardActions, CardContent, Typography } from "@mui/material";

interface DescriptionComponent {
    project: any;
}
export const DescriptionComponent = ({ project }: DescriptionComponent) => {
    return (
        <Box className="recentNotesWrapper">
            <Box className="subHead2">
                <Typography variant="h3" className="primaryColor" style={{ marginBottom: '5px' }}>
                    Description
                </Typography>
            </Box>
            {
                project?.description && (
                    <Box className="recentNotesContainer" sx={{ pr: 2 }}>
                        <Card elevation={0} sx={{ mb: 1 }}>
                            <CardContent>
                                <Typography variant="body1">{project?.description}</Typography>
                            </CardContent>
                            {/* <CardActions disableSpacing>
                                <Typography variant="caption" fontStyle={'italic'}>
                                    Created on: <i>{project?.createdOn}</i>
                                </Typography>
                            </CardActions> */}
                        </Card>
                    </Box>
                )
            }
        </Box>
    );
}